// Shared CMS constants and helpers (frontend).
// Keep field keys in sync with backend `/app/backend/cms.py`.

export const CATEGORIES = [
  "Income Tax",
  "GST",
  "Company and SEBI Laws",
  "FEMA and FCRA",
  "International Tax",
  "Transfer Pricing",
  "Labour Laws",
];

export const CONTENT_TYPES = [
  { key: "case_law", label: "Case Laws" },
  { key: "act", label: "Acts and Statutes" },
  { key: "circular", label: "Circulars and Notifications" },
  { key: "alert", label: "Regulatory Alerts" },
  { key: "blog", label: "Blogs" },
];

export const CONTENT_TYPE_LABEL = Object.fromEntries(
  CONTENT_TYPES.map((c) => [c.key, c.label])
);

export const COURTS = [
  "Supreme Court of India",
  "High Courts",
  "ITAT",
  "CESTAT",
  "AAR",
  "AAAR",
  "NCLAT",
  "SAT",
  "Other",
];

export const AUTHORITIES = [
  "CBDT",
  "CBIC",
  "MCA",
  "SEBI",
  "RBI",
  "FEMA",
  "IRDAI",
  "PFRDA",
  "Ministry of Labour",
  "Other",
];

export const DOC_TYPES = [
  "Circular",
  "Notification",
  "Press Release",
  "Instruction",
  "Order",
  "Clarification",
];

export const URGENCY = [
  { key: "high", label: "High", color: "#DC2626", bg: "#FEE2E2" },
  { key: "medium", label: "Medium", color: "#B45309", bg: "#FEF3C7" },
  { key: "low", label: "Low", color: "#475569", bg: "#F1F5F9" },
];

export function slugify(str) {
  return (str || "")
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80);
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
